import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { errorsWithParamsMapper } from '../../hooks/utils'
import { EditPaapiSchema } from '../../schemas/editPaapiSchema'
import { toDTO } from './api/mapper'
import { UPDATE_PAAPI_PREBID_MODULE } from './api/mutation'
import { Data } from './api/types'
import { UseUpdatePaapiPrebidModule } from './types'

export const useUpdatePaapiPrebidModule = (): UseUpdatePaapiPrebidModule => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.modules.general.edit.general.paapi.update',
  })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<EditPaapiSchema>>({})

  const [mutate] = useMutation(UPDATE_PAAPI_PREBID_MODULE, {
    onCompleted: ({ updatePaapiPrebidModule: { errors, workspacePrebidModule } }: Data): void => {
      if (errors && errors.length > 0) {
        setErrors(errorsWithParamsMapper<EditPaapiSchema>(errors))
        enqueueSnackbar(t('error'), { variant: 'error' })
      } else if (workspacePrebidModule) {
        setErrors({})
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
  })

  const update: UseUpdatePaapiPrebidModule['update'] = data => {
    mutate({
      variables: {
        input: toDTO(data),
      },
    })
  }

  return { errors, update }
}
